module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-44.1433ae01.png";